import { lazy } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import MasterRoute from "./masterRoute";
import AdminLevelRoute from "./adminLevelRoute";

export const Home = lazy(() => import("../pages/dashBoard/Home"));
export const Login = lazy(() => import("../pages/login/index"));
export const Repassword = lazy(() => import("../pages/Repassword"));
export const BookingDiscount = lazy(() => import("../pages/bookingDiscount"));
export const BookingDiscountCreate = lazy(() =>
  import("../pages/bookingDiscount/create")
);
export const BookingDiscountReservation = lazy(() =>
  import("../pages/bookingDiscount/reservation")
);
export const GolfInfomation = lazy(() => import("../pages/golfInformation"));
export const GolfInfomationModify = lazy(() =>
  import("../pages/golfInformation/modify")
);
export const GolfAcount = lazy(() => import("../pages/golfAccount"));
export const YearBookingList = lazy(() => import("../pages/yearBookingList"));
export const YearBookingDetail = lazy(() =>
  import("../pages/yearBookingDetail")
);
export const YearBookingRoundingList = lazy(() =>
  import("../pages/yearBookingRoundingList")
);
export const YearBookingRoundingDetail = lazy(() =>
  import("../pages/yearBookingRoundingDetail")
);
export const YearBookingRoundingDummyDetail = lazy(() =>
  import("../pages/yearBookingRoundingList/DummyDetail")
);
export const YearBookingGroups = lazy(() =>
  import("../pages/yearBookingGroups")
);
export const YearBookingGroupsDetail = lazy(() =>
  import("../pages/yearBookingGroups/id")
);
export const YearBookingGroupsDummyDetail = lazy(() =>
  import("../pages/yearBookingGroups/DummyDetail")
);
export const NoYearBookingGroups = lazy(() =>
  import("../pages/noYearBookingGroups")
);
export const EventBookingList = lazy(() => import("../pages/eventBookingList"));
export const EventBookingDetail = lazy(() =>
  import("../pages/eventBookingDetail")
);
export const EventBookingRoundingList = lazy(() =>
  import("../pages/eventBookingRoundingList")
);
export const EventBookingRoundingDetail = lazy(() =>
  import("../pages/eventBookingRoundingDetail")
);
export const ErpBookingList = lazy(() => import("../pages/ErpBooking"));
export const ErpBookingDetail = lazy(() =>
  import("../pages/ErpBookingDetail/index")
);
export const ErpRequestList = lazy(() => import("../pages/erpRequestList"));
export const ErpRequestDetail = lazy(() => import("../pages/erpRequestDetail"));

export const LogList = lazy(() => import("../pages/logList"));
export const SearchResults = lazy(() => import("../pages/SearchResults"));
export const EventList = lazy(() => import("../pages/event"));
export const EventDetail = lazy(() => import("../pages/event/detail"));
export const RealtimeTimeline = lazy(() => import("../pages/analytics/RealtimeTimeline"));

export default function Router() {
  const routes = useRoutes([
    // {
    //     path: '/',
    //     element: <Home />,
    //     index: true,
    // },
    {
      path: "/",
      element: <PrivateRoute />,
      children: [
        {
          element: <MasterRoute />,
          children: [
            {
              path: "yb/noYearBookingGroups",
              element: <NoYearBookingGroups />,
            },
            { path: "analytics/timeline", element: <RealtimeTimeline /> },
          ],
        },
        { element: <Navigate to="/home" replace />, index: true },
        {
          path: "home",
          element: <Home />,
        },
        {
          path: "dc/bookingdiscountList",
          element: <BookingDiscount />,
        },
        {
          path: "dc/bookingdiscountList/create/:id",
          element: <BookingDiscountCreate />,
        },
        {
          path: "dc/bookingdiscountrsvps",
          element: <BookingDiscountReservation />,
        },
        { path: "common/golfinfo", element: <GolfInfomation /> },
        {
          path: "common/golfinfo/modify/:id",
          element: <GolfInfomationModify />,
        },
        {
          path: "common/golfinfo/event",
          element: <EventList />,
        },
        {
          path: "common/golfinfo/event/create",
          element: <EventDetail />,
        },
        {
          path: "common/golfinfo/event/:id",
          element: <EventDetail />,
        },
        { path: "common/golfacount", element: <GolfAcount /> },
        { path: "common/logList", element: <LogList /> },
        { path: "yb/yearBookingList", element: <YearBookingList /> },
        {
          path: "yb/yearBookingList/:id",
          element: <YearBookingDetail />,
        },
        {
          path: "yb/yearBookingRoundingList",
          element: <YearBookingRoundingList />,
        },
        {
          path: "yb/yearBookingRoundingList/dummy/:id",
          element: <YearBookingRoundingDummyDetail />,
        },
        {
          path: "yb/yearBookingRoundingList/:id",
          element: <YearBookingRoundingDetail />,
        },
        {
          path: "yb/yearBookingGroups",
          element: (
            <AdminLevelRoute allowedLevels={[1, 2, 3, 4, 5, 6, 7, 8, 10]}>
              <YearBookingGroups />
            </AdminLevelRoute>
          ),
        },
        {
          path: "yb/yearBookingGroups/dummy/:id",
          element: (
            <AdminLevelRoute allowedLevels={[1, 2, 3, 4, 5, 6, 7, 8, 10]}>
              <YearBookingGroupsDummyDetail />
            </AdminLevelRoute>
          ),
        },
        {
          path: "yb/yearBookingGroups/:id",
          element: (
            <AdminLevelRoute allowedLevels={[1, 2, 3, 4, 5, 6, 7, 8, 10]}>
              <YearBookingGroupsDetail />
            </AdminLevelRoute>
          ),
        },
        {
          path: "eb/eventBookingList",
          element: <EventBookingList />,
        },
        {
          path: "eb/eventBookingList/:id",
          element: <EventBookingDetail />,
        },
        {
          path: "eb/eventBookingRoundingList",
          element: <EventBookingRoundingList />,
        },
        {
          path: "eb/eventBookingRoundingList/:id",
          element: <EventBookingRoundingDetail />,
        },
        {
          path: "erp/erpBookingList",
          element: <ErpBookingList />,
        },
        {
          path: "erp/erpBookingList/:id",
          element: <ErpBookingDetail />,
        },
        {
          path: "erp/erpRequestList",
          element: (
            <AdminLevelRoute allowedLevels={[10]}>
              <ErpRequestList />
            </AdminLevelRoute>
          ),
        },
        {
          path: "erp/erpRequestList/:id",
          element: (
            <AdminLevelRoute allowedLevels={[10]}>
              <ErpRequestDetail />
            </AdminLevelRoute>
          ),
        },
        {
          path: "search",
          element: <SearchResults />,
        },
      ],
    },
    {
      path: "login",
      element: <Login />,
    },
    {
      path: "repassword",
      element: <Repassword />,
    },
    {
      path: "*",
      element: <Navigate to={"/"} />,
    },
  ]);

  return routes;
}
